module.exports = __webpack_public_path__ + "img/media-yinli.05e2eafe.png";